import { useState } from "react";
import "../../styles/art/pages/Design24About.css";

function Design24About() {
  const [activeSection, setActiveSection] = useState("who");

  return (
    <main className="design24-about">
      <nav className="design24-about__sidebar">
        <ul className="design24-about__list">
          <li
            className={`design24-about__item ${
              activeSection === "who" ? "design24-about__item--active" : ""
            }`}
            onClick={() => setActiveSection("who")}
          >
            MỸ THUẬT DESIGN24 LÀ AI?
          </li>
          <li
            className={`design24-about__item ${
              activeSection === "features" ? "design24-about__item--active" : ""
            }`}
            onClick={() => setActiveSection("features")}
          >
            ĐẶC TRƯNG CỦA THƯƠNG HIỆU DESIGN24
          </li>
          <li
            className={`design24-about__item ${
              activeSection === "team" ? "design24-about__item--active" : ""
            }`}
            onClick={() => setActiveSection("team")}
          >
            ĐỘI NGŨ & CƠ SỞ VẬT CHẤT
          </li>
          <li
            className={`design24-about__item ${
              activeSection === "testimonials"
                ? "design24-about__item--active"
                : ""
            }`}
            onClick={() => setActiveSection("testimonials")}
          >
            LỜI CHỨNG THỰC
          </li>
          <li
            className={`design24-about__item ${
              activeSection === "faq" ? "design24-about__item--active" : ""
            }`}
            onClick={() => setActiveSection("faq")}
          >
            CÂU HỎI THƯỜNG GẶP
          </li>
        </ul>
      </nav>

      <section className="design24-about__content">
        {activeSection === "who" && (
          <>
            <h1 className="design24-about__title">MỸ THUẬT DESIGN24 LÀ AI?</h1>
            <p className="design24-about__text">
              Hệ thống đào tạo mỹ thuật thiếu nhi <strong>Design24</strong> là
              một trong những thương hiệu hàng đầu trong ngành giáo dục mỹ thuật
              ứng dụng tại Việt Nam, với chương trình đào tạo dành cho các học
              viên từ 3,5 đến 16 tuổi dựa trên nền tảng Giáo dục Quốc tế
              Singapore. Với mong muốn mọi trẻ em đều được phát triển tính cách
              tốt cùng lối suy nghĩ logic vấn đề, tư duy sáng tạo thông qua học
              Vẽ.
            </p>
          </>
        )}

        {activeSection === "features" && (
          <>
            <h1 className="design24-about__title">
              ĐẶC TRƯNG CỦA THƯƠNG HIỆU DESIGN24
            </h1>
            <article className="design24-about__article">
              <h2 className="design24-about__subtitle">Tầm nhìn</h2>
              <p className="design24-about__text">
                <strong>Design24</strong> mong muốn sẽ là nơi dẫn đầu trong việc
                đào tạo mỹ thuật chuyên nghiệp dành cho trẻ em. Thông qua việc
                học vẽ giúp con xây dựng các giá trị cốt lõi về ý thức, tính
                cách và trí tuệ. Đồng thời, <strong>Design24</strong> còn góp
                phần kiến tạo thói quen, nhân cách tốt, giúp con trẻ trở thành
                những nhà lãnh đạo tốt trong tương lai.
              </p>
            </article>
            <article className="design24-about__article">
              <h2 className="design24-about__subtitle">Sứ mệnh</h2>
              <p className="design24-about__text">
                <strong>Design24</strong> luôn vận động và chuyển mình liên tục
                để không ngừng hoàn thiện và nâng cao chất lượng hệ thống. Với
                mong muốn xây dựng thêm nhiều trung tâm đào tạo mỹ thuật mang
                tiêu chuẩn Quốc tế để đem đến cho học viên nhiều kiến thức bổ
                ích trong việc phát triển tính cách, tư duy sáng tạo về cái đẹp.
              </p>
            </article>
            <article className="design24-about__article">
              <h2 className="design24-about__subtitle">Mục tiêu hoạt động</h2>
              <p className="design24-about__text">
                Hiện nay các chương trình học ở trường gây nhiều áp lực và căng
                thẳng cho con trẻ. Vì vậy Mỹ thuật <strong>Design24</strong> ra
                đời nhằm tạo ra các sân chơi và hoạt động bổ ích, mang đến niềm
                vui và sự thoải mái, cân bằng lại nhịp sinh học cho các con.
                Thông qua đó giúp các con có cơ hội được giao lưu, học hỏi và
                hơn hết là nhận được sự động viên, khích lệ từ mọi người. Từ đó
                giúp cho con trẻ đam mê, tự tin vào khả năng, giá trị của bản
                thân mình được cộng đồng công nhận.
              </p>
              <p className="design24-about__text">
                Nghệ thuật của <strong>Design24</strong> có vai trò tác động và
                kích thích vào não bộ của trẻ, giúp con ghi nhớ và biết cách
                quan sát, xử lý logic và sáng tạo các vấn đề trong cuộc sống.
                Đồng thời tạo nên mối liên kết cảm xúc mạnh mẽ, giúp trẻ tự tin
                trong việc thể hiện ý tưởng, cảm xúc và tư duy một cách tự nhiên
                nhất.
              </p>
            </article>
          </>
        )}

        {activeSection === "team" && (
          <>
            <h1 className="design24-about__title">ĐỘI NGŨ & CƠ SỞ VẬT CHẤT</h1>
            <article className="design24-about__article">
              <h2 className="design24-about__subtitle">Đội ngũ giảng viên</h2>
              <p className="design24-about__text">
                Đội ngũ giáo viên tại Design24 đều là những chuyên gia mỹ thuật
                với nhiều năm kinh nghiệm, tận tâm đào tạo và phát triển năng
                lực sáng tạo của trẻ.
              </p>
            </article>
            <article className="design24-about__article">
              <h2 className="design24-about__subtitle">Cơ sở vật chất</h2>
              <p className="design24-about__text">
                Các phòng học được trang bị hiện đại, không gian sáng tạo thân
                thiện với trẻ, giúp các con cảm thấy thoải mái và hứng thú trong
                mỗi buổi học.
              </p>
              {/* Bạn có thể thêm ảnh ở đây */}
            </article>
          </>
        )}

        {activeSection === "testimonials" && (
          <>
            <h1 className="design24-about__title">LỜI CHỨNG THỰC</h1>
            <article className="design24-about__article">
              <p className="design24-about__text">
                “Con tôi đã tiến bộ rõ rệt về khả năng sáng tạo và tư duy logic
                sau khi học tại Design24. Giáo viên rất tận tâm và chương trình
                rất phù hợp với trẻ nhỏ.”
                <br />— Phụ huynh anh Minh, Ninh Kiều
              </p>
            </article>
            <article className="design24-about__article">
              <p className="design24-about__text">
                “Design24 là môi trường tuyệt vời để mình phát triển kỹ năng mỹ
                thuật và tự tin hơn trong cuộc sống.”
                <br />— Học viên Nguyễn Thảo, 14 tuổi
              </p>
            </article>
          </>
        )}

        {activeSection === "faq" && (
          <>
            <h1 className="design24-about__title">CÂU HỎI THƯỜNG GẶP</h1>

            <details className="design24-about__faq-item">
              <summary>Độ tuổi nào phù hợp để đăng ký học?</summary>
              <p>Chương trình dành cho học viên từ 3,5 đến 16 tuổi.</p>
            </details>

            <details className="design24-about__faq-item">
              <summary>Học phí và lịch học như thế nào?</summary>
              <p>
                Học phí linh hoạt theo từng khóa học, lịch học được thiết kế ưu
                tiên phù hợp với học viên và phụ huynh.
              </p>
            </details>

            <details className="design24-about__faq-item">
              <summary>
                Chương trình học có bằng cấp hoặc chứng chỉ sau khi hoàn thành
                không?
              </summary>
              <p>
                Học viên sẽ nhận được chứng chỉ hoàn thành khóa học do Design24
                cấp, có giá trị khẳng định kỹ năng và kiến thức đã học.
              </p>
            </details>

            <details className="design24-about__faq-item">
              <summary>
                Giáo viên có chuyên môn và kinh nghiệm như thế nào?
              </summary>
              <p>
                Đội ngũ giáo viên tại Design24 đều có bằng cấp chuyên ngành Mỹ
                thuật và kinh nghiệm giảng dạy thiếu nhi lâu năm, đảm bảo chất
                lượng đào tạo tốt nhất.
              </p>
            </details>

            <details className="design24-about__faq-item">
              <summary>Có hỗ trợ học viên ngoài giờ học không?</summary>
              <p>
                Chúng tôi có các buổi tư vấn, hỗ trợ kỹ thuật và động viên học
                viên ngoài giờ học chính để đảm bảo sự tiến bộ liên tục.
              </p>
            </details>

            <details className="design24-about__faq-item">
              <summary>Làm thế nào để đăng ký hoặc tư vấn khóa học?</summary>
              <p>
                Quý phụ huynh và học viên có thể liên hệ trực tiếp qua website
                hoặc đến các trung tâm để được tư vấn và đăng ký khóa học phù
                hợp.
              </p>
            </details>

            <details className="design24-about__faq-item">
              <summary>
                Có các hoạt động ngoại khóa hoặc triển lãm tranh nào không?
              </summary>
              <p>
                Design24 thường xuyên tổ chức các hoạt động ngoại khóa, cuộc thi
                và triển lãm tranh nhằm khuyến khích sự sáng tạo và phát triển
                toàn diện cho học viên.
              </p>
            </details>
          </>
        )}
      </section>
    </main>
  );
}

export default Design24About;
